import axiosInstance from './axiosInstance';
import { mockPatientApi } from './mockPatientApi';

// Determine if we should use mock data (for development)
const USE_MOCK_DATA =
  process.env.REACT_APP_USE_MOCK_DATA === 'true' ||
  !process.env.REACT_APP_API_URL;

export const patientApi = {
  // Dashboard endpoints
  getDashboardStats: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getDashboardStats()
      : axiosInstance.get('/patient/dashboard/stats/'),

  getAppointmentHistory: (months = 6) =>
    USE_MOCK_DATA
      ? mockPatientApi.getAppointmentHistory(months)
      : axiosInstance.get(
          `/patient/dashboard/appointment-history/?months=${months}`
        ),

  getHealthSummary: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getHealthSummary()
      : axiosInstance.get('/patient/dashboard/health-summary/'),

  // Additional endpoints that might be useful
  getRecentAppointments: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getRecentAppointments()
      : axiosInstance.get('/patient/appointments/recent/'),

  getUpcomingAppointments: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getUpcomingAppointments()
      : axiosInstance.get('/patient/appointments/upcoming/'),

  getPrescriptions: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getPrescriptions()
      : axiosInstance.get('/patient/prescriptions/'),

  getHealthMetrics: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getHealthMetrics()
      : axiosInstance.get('/patient/health-metrics/'),

  // New Patient Dashboard Endpoints
  
  // Messaging
  getMessageThreads: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getMessageThreads()
      : axiosInstance.get('/patient/messages/'),

  getMessages: (threadId) =>
    USE_MOCK_DATA
      ? mockPatientApi.getMessages(threadId)
      : axiosInstance.get(`/patient/messages/${threadId}/`),

  sendMessage: (data) =>
    USE_MOCK_DATA
      ? mockPatientApi.sendMessage(data)
      : axiosInstance.post('/patient/messages/send/', data),

  // Billing
  getInvoices: (params = {}) =>
    USE_MOCK_DATA
      ? mockPatientApi.getInvoices(params)
      : axiosInstance.get('/patient/invoices/', { params }),

  getInvoiceDetail: (invoiceId) =>
    USE_MOCK_DATA
      ? mockPatientApi.getInvoiceDetail(invoiceId)
      : axiosInstance.get(`/patient/invoices/${invoiceId}/`),

  downloadInvoicePDF: (invoiceId) =>
    USE_MOCK_DATA
      ? mockPatientApi.downloadInvoicePDF(invoiceId)
      : axiosInstance.get(`/patient/invoices/${invoiceId}/pdf/`, {
          responseType: 'blob'
        }),

  // Feedback
  getFeedbackHistory: () =>
    USE_MOCK_DATA
      ? mockPatientApi.getFeedbackHistory()
      : axiosInstance.get('/patient/feedback/'),

  submitFeedback: (doctorId, data) =>
    USE_MOCK_DATA
      ? mockPatientApi.submitFeedback(doctorId, data)
      : axiosInstance.post(`/patient/feedback/doctor/${doctorId}/`, data),

  // Other patient endpoints...
};
